export default __webpack_public_path__ + "static/media/003-Eiffel Tower.92cd2ced.svg";